

const StartSliderSection = () => {
  return (
    <>
  {/* Start Slider Section */}
  <section
    className="slider-section-fourteen wow fadeInUp"
    data-wow-duration="1s"
  >
    <div
      className="horizontal-slide slide-fourteen  d-flex"
      data-direction="left"
      data-speed="slow"
    >
      <div className="slide-list d-flex gap-4">
        <div className="services-slide">
          <h3 className="custom-title">
            Hydrafacial Starting from ₹999 Limited Offer
          </h3>
        </div>
        <div className="services-slide">
          <h3 className="custom-title">
            Flat 25% Off on Anti-Aging Treatments
          </h3>
        </div>
        <div className="services-slide">
          <h3 className="custom-title">
            Offer : 15% Discount on First Appointment
          </h3>
        </div>
        <div className="services-slide">
          <h3 className="custom-title">
            Summer Skin Care Offers Available Now
          </h3>
        </div>
      </div>
    </div>
  </section>
  {/* End Slider Section */}
</>

  )
}

export default StartSliderSection